enum KeyCaptcha {
  SITE_KEY = '6LeX7TsgAAAAAErZlOCTHikH3rYIEVSKGGsMFy1g',
  SECURITY_KEY = '6LeX7TsgAAAAAGmM8Qf2VOkyVHWTowXMT-vDOFWu',
}

export { KeyCaptcha };
